import $ from 'jquery';
import Panzoom from '@panzoom/panzoom'
const modalgalery = document.querySelector('.modalgalery');
const closegalery = document.querySelector(".modalgalery-close");

if (document.querySelector(".product-slider")) {

    const productSliders = document.querySelectorAll(".product-slider__slider");

    productSliders.forEach(slider => {
        $(slider).slick({
            slidesToShow: Number(slider.dataset.slides),
            slidesToScroll: Number(slider.dataset.slides),
            appendArrows: $(slider.closest(".product-slider").querySelector(".slider-controls__arrows")),
            prevArrow: "<button type='button' class='slick-prev d-none d-md-block'><i class='fal fa-chevron-left'></i></button>",
            nextArrow: "<button type='button' class='slick-next'><i class='fal fa-chevron-right'></i></button>",
            dots: true,
            appendDots: $(slider.closest(".product-slider").querySelector(".slider-controls__dots")),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

}

if(document.querySelector(".products-galeria--slider")){
    const galerias= document.querySelectorAll(".products-galeria--slider");
    const overlays = document.querySelectorAll(".overlay-products");
    const elemActive = document.querySelector(".panzoom-element");
    const zoomInButton = document.querySelector(".modalgalery-controls .zoomInButton");
    const zoomOutButton = document.querySelector(".modalgalery-controls .zoomOutButton ");
    const resetButton = document.querySelector(".modalgalery-controls .resetButton");
    const nextArrow = document.querySelector(".modalgalery-arrow.next");
    const prevArrow = document.querySelector(".modalgalery-arrow.prev");
    const tumbsul = document.querySelector(".modalgalery-body .tumbs .tumbs-ul");
    const tumbsli = document.querySelectorAll(".modalgalery-body .tumbs .tumbs-ul li");
    var tumbactive = document.querySelector(".modalgalery-body .tumbs .tumbs-ul .active");
    galerias.forEach(slider => {
        $(slider).slick({
            slidesToShow:1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
    

    overlays.forEach(image=>{
        image.addEventListener("click", e=>{
            modalgalery.style.display = "flex";
        })
    });
    if(closegalery){
        closegalery.addEventListener("click", e=>{
            modalgalery.style.display = "none";
        });
    }

    const panzoom = Panzoom(elemActive);
    zoomInButton.addEventListener('click', panzoom.zoomIn);
    zoomOutButton.addEventListener('click', panzoom.zoomOut);
    resetButton.addEventListener('click', panzoom.reset);

    nextArrow.addEventListener("click", e=>{
        let actual = Number(tumbactive.dataset.item);
        let next = document.querySelector(`.modalgalery-body .tumbs .tumbs-ul li[data-item="${actual+1}"`);
        if(!next){
            next = document.querySelector(`.modalgalery-body .tumbs .tumbs-ul li[data-item="${1}"`);
        } 
        tumbactive.classList.remove("active");
        tumbactive.classList.add("inactive");
        next.classList.add("active");
        next.classList.remove("inactive");
        tumbactive=next;
        elemActive.src=next.dataset.url;
        
    });
    prevArrow.addEventListener("click", e=>{
        let actual = Number(tumbactive.dataset.item);
        let prev = document.querySelector(`.modalgalery-body .tumbs .tumbs-ul li[data-item="${actual-1}"`);
        if(!prev){
            let lastelement = Number(tumbsul.dataset.total);
             prev = document.querySelector(`.modalgalery-body .tumbs .tumbs-ul li[data-item="${lastelement}"`);
        }
        tumbactive.classList.remove("active");
        tumbactive.classList.add("inactive");
        prev.classList.add("active");
        prev.classList.remove("inactive");
        tumbactive=prev;
        elemActive.src=prev.dataset.url;
    });

    tumbsli.forEach(el=>{
        el.addEventListener("click", e=>{
            let element = e.target;
            tumbactive.classList.remove("active");
            tumbactive.classList.add("inactive");
            element.classList.add("active");
            element.classList.remove("inactive");
            tumbactive=element;
            elemActive.src=element.dataset.url;
        })
    })
      
}